import {RedirectCommon} from '../RedirectCommon';

const NotAllowed = () => {
  return RedirectCommon.renderNotAllowedMTAStatic();
}

export default NotAllowed;
